// removed by extract-text-webpack-plugin
module.exports = {"block":"Glmdv1Iu-shc40nIFOF4_","zebra":"_31B25HPcWbGtZLAB3r-ZY","content":"sz2IovELTP00S_U_NSviU","has-overflow":"R6ZCQ8VL0g6C7tkCDq82d","yellow":"Qtp4HBssyr6OPftyAeVZ-","darkgray":"_354gJ363Oe7-b42pUDqGtd","table-text":"_2ZvIh7-HsVMR_xOvFay8bn","heading":"_1AV0fKIxbQAO5Zx_g7TwV_","had-interaction":"_5tjHnQguhpL-z7ZcOjJrP","swipe-hint":"_24nbq4o4LMXG9-rkR2FAud","table-swipe":"_2jzC42MmO2S_foacAdf9wB","swipe-hint-hand":"_3rC_1PdyBb0G56kAWD48gi","swipe-hint-trail":"DIajf8cwaJsB3YnxKfFo","readMore":"_2KoEwcBVciVuIVSvChGgu9","rightAlign":"_2nFSj17Cwhjqi6CKKo2vEP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TableBlock/TableBlock.module.scss
// module id = 810
// module chunks = 0